import { ga4Event } from '@utils/analytics/ga4';
import { clarityEvent, claritySetTags } from '@utils/analytics/clarity';

// paulinaTrack — MISMO util de telemetría que `usePaulinaChat` usa para los eventos `pau_*`
// (extraído para reusarlo desde las superficies de invitación / feedback del rollout sin
// duplicar la lógica). Manda el evento a GA4 (con params) y a Clarity (tag de sesión
// `pau_usuario` + evento por nombre — Clarity solo recibe el nombre, sin PII).
//
// IMPORTANTE: Clarity se envía con los helpers canónicos `clarityEvent`/`claritySetTags`
// (SDK oficial `@microsoft/clarity`), los MISMOS que usa el resto de la app y la rollout.
// Antes se usaba el `window.clarity` crudo, que NO existe con ese paquete (es modular y no
// expone el global) → `typeof window.clarity === 'function'` era siempre false y los eventos
// de Paulina NUNCA llegaban a Clarity (a GA4 sí). Por eso no aparecían las métricas.
//
// La telemetría NUNCA rompe la UI (los helpers ya van en try/catch; este extra es defensa).
// Convención de naming: `pau_<dominio>_<accion>` (dominio + acción en pasado).
export const paulinaTrack = (eventName: string, params: Record<string, string | number | boolean> = {}): void => {
  try {
    // GA4: evento + propiedades (la analítica de Paulina vive aquí).
    ga4Event(eventName, params);
    // Clarity: el nombre del evento se manda como TAG (`pau_evento`) además del
    // custom event. Los tags SÍ aparecen/se filtran en Clarity (igual que la rollout
    // y que `pau_usuario`); los `event` custom quedan en otra vista. Clarity acumula
    // los valores de un tag por sesión → todos los `pau_*` quedan filtrables. Sin PII
    // (las propiedades por evento van solo a GA4).
    claritySetTags({ pau_usuario: 'true', pau_evento: eventName });
    clarityEvent(eventName);
  } catch {
    /* la telemetría nunca rompe la UI */
  }
};
